import { render } from "./LoadingBar.vue?vue&type=template&id=55a7a64b&scoped=true"
import script from "./LoadingBar.vue?vue&type=script&lang=js"
export * from "./LoadingBar.vue?vue&type=script&lang=js"

import "./LoadingBar.vue?vue&type=style&index=0&id=55a7a64b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55a7a64b"]])

export default __exports__